import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Building2, Truck, ExternalLink } from 'lucide-react';
type Supplier = {
  name: string;
  accent: string;
  link?: string;
};
const suppliers: Supplier[] = [{
  name: 'Freightliner Orlando',
  accent: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
  link: 'https://share.google/P73jEI5s10e774oNk'
}, {
  name: 'Freightliner Apopka',
  accent: 'bg-blue-500/10 text-blue-600 dark:text-blue-400',
  link: 'https://share.google/6B01jIAinMkoYwHY3'
}, {
  name: 'Nextran',
  accent: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  link: 'https://share.google/D5w3nfxWbjbBwtHax'
}, {
  name: 'Rush Truck',
  accent: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  link: 'https://www.google.com/search?q=rush+truck+center'
}, {
  name: 'Kenworth',
  accent: 'bg-rose-500/10 text-rose-600 dark:text-rose-400',
  link: 'https://share.google/7USYJ0sIyPv3Lv7LN'
}, {
  name: 'Cumberland International',
  accent: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
  link: 'https://share.google/dOxFaeIuPk3nxeyZ6'
}, {
  name: 'Truck Zone',
  accent: 'bg-cyan-500/10 text-cyan-600 dark:text-cyan-400'
}, {
  name: 'Truck Pro',
  accent: 'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400',
  link: 'https://share.google/ul3QlTkwu412MshNb'
}, {
  name: 'Amazon Hose & Rubber',
  accent: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
  link: 'https://www.google.com/search?q=amazon+hose+and+rubber+google+maps'
}, {
  name: 'Utility Trailer',
  accent: 'bg-teal-500/10 text-teal-600 dark:text-teal-400',
  link: 'https://share.google/5A4rfiPkvEViVKFuh'
}, {
  name: 'Wabash',
  accent: 'bg-sky-500/10 text-sky-600 dark:text-sky-400',
  link: 'https://share.google/TwNfpH81YMb1vKnWs'
}, {
  name: 'FleetPride',
  accent: 'bg-purple-500/10 text-purple-600 dark:text-purple-400',
  link: 'https://share.google/3BSMkwISEGWx3YPbU'
}, {
  name: "David's Trailers",
  accent: 'bg-fuchsia-500/10 text-fuchsia-600 dark:text-fuchsia-400',
  link: 'https://share.google/VvuHNEv5QIKPGMq2C'
}, {
  name: 'Royal Brass & Rubber',
  accent: 'bg-orange-500/10 text-orange-600 dark:text-orange-400',
  link: 'https://share.google/rZjV1AVjIeyxFxKKn'
}, {
  name: 'American Tire Distribuitors',
  accent: 'bg-red-500/10 text-red-600 dark:text-red-400',
  link: 'https://share.google/gfWCAWmFfCtlXmLSL'
}, {
  name: 'Lutone Tire Center',
  accent: 'bg-blue-500/10 text-blue-600 dark:text-blue-400'
}, {
  name: 'Santos Tire',
  accent: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  link: 'https://share.google/04vESpscFd0Db6FIV'
}, {
  name: 'MPF Truck Solutions',
  accent: 'bg-indigo-500/10 text-indigo-600 dark:text-indigo-400',
  link: 'https://share.google/2laTyR2voEioIvJAG'
}, {
  name: "Charley's Tire",
  accent: 'bg-rose-500/10 text-rose-600 dark:text-rose-400',
  link: 'https://share.google/8FRoneW6oXqj8bGF6'
}, {
  name: 'AtisVen (Venus24h)',
  accent: 'bg-amber-500/10 text-amber-600 dark:text-amber-400',
  link: 'https://wa.me/16892600128'
}];
function SupplierCard({
  supplier
}: {
  supplier: Supplier;
}) {
  const hasLink = !!supplier.link;
  const Wrapper: any = hasLink ? 'a' : 'div';
  const wrapperProps = hasLink ? {
    href: supplier.link,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return <Wrapper {...wrapperProps} className={`group relative flex flex-col items-center justify-center text-center rounded-xl border bg-card p-6 shadow-sm transition-all aspect-square ${hasLink ? 'hover:shadow-md hover:border-primary/40 cursor-pointer' : 'opacity-90'}`} data-id="element-334" data-mp="2z6svua0hev66">
      {/* External link signal */}
      <div className={`absolute top-3 right-3 flex h-7 w-7 items-center justify-center rounded-full transition-all ${hasLink ? 'bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground group-hover:scale-110' : 'bg-muted text-muted-foreground/40'}`} title={hasLink ? 'View location details' : 'No link yet'} data-id="element-335" data-mp="2bgouk9arn7ic">
        <ExternalLink className="h-3.5 w-3.5" data-id="element-336" data-mp="m0mc31maqt2f" />
      </div>

      <div className={`flex h-16 w-16 items-center justify-center rounded-2xl mb-4 transition-transform ${hasLink ? 'group-hover:scale-110' : ''} ${supplier.accent}`} data-id="element-337" data-mp="lzb56sxk1573">
        <Building2 className="h-8 w-8" data-id="element-338" data-mp="vqnyloz043f8" />
      </div>
      <h3 className="text-lg font-semibold text-foreground leading-tight" data-id="element-339" data-mp="19r8dwb5pjh3z">
        {supplier.name}
      </h3>
    </Wrapper>;
}
export function SupplierNetwork() {
  // Scroll to top whenever this page mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, []);
  return <motion.div initial={{
    opacity: 0,
    y: 16
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4
  }} className="mx-auto max-w-6xl pb-16" data-id="element-340" data-mp="36k0i6zoih3b2">
      {/* Back link */}
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6" data-id="element-341" data-mp="1cb4w57gb7mkn">
        <ArrowLeft className="h-4 w-4" data-id="element-342" data-mp="1h8erf3qdqsge" />
        Back to Home
      </Link>

      {/* Header */}
      <div className="mb-10" data-id="element-343" data-mp="138vmejsv7x8b">
        <div className="mb-4 flex items-center gap-3 text-primary" data-id="element-344" data-mp="189jk1oblncbi">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10" data-id="element-345" data-mp="18auo7p8yim35">
            <Truck className="h-5 w-5" data-id="element-346" data-mp="tdtxnp2i4x69" />
          </div>
          <span className="font-semibold tracking-wider text-sm uppercase" data-id="element-347" data-mp="yau1dtbvpnu7">
            Supplier Network
          </span>
        </div>
        <h1 className="text-4xl font-bold tracking-tight text-foreground sm:text-5xl mb-4" data-id="element-348" data-mp="2nqtgrs63c9ia">
          Trusted Industry Partners
        </h1>
        <p className="text-xl text-muted-foreground leading-relaxed max-w-3xl" data-id="element-349" data-mp="2r87rkoo1w8x9">
          Active vendor relationships, dealership networks, and parts suppliers
          that keep operations running 24/7. Click the icon on any card to view
          location details.
        </p>
      </div>

      {/* Supplier grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4" data-id="element-350" data-mp="2d8y8nh8gn0pl">
        {suppliers.map(s => <SupplierCard key={s.name} supplier={s} data-id="element-351" data-mp="39xe1bm6v9q6x" />)}
      </div>
    </motion.div>;
}